import { useCallback, useState } from 'react';

export function useBooleanStateWithToggle(initialValue = false) {
  const [value, setValue] = useState(initialValue);
  const toggleValue = useCallback(() => setValue((oldValue) => !oldValue), [setValue]);

  return [value, toggleValue] as const;
}
